import { render } from "./CreateEditStudentAssistant.vue?vue&type=template&id=a0dbc914"
import script from "./CreateEditStudentAssistant.vue?vue&type=script&lang=js"
export * from "./CreateEditStudentAssistant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__